export const bloodTestDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp:",
        tokenNo: "Token No:",
        beneficiaryName: "Beneficiary Name:",
        campDate: "Camp Date:",
        createdBy: "Created By:",

        testTypesAndRemarks: "Test Types & Remarks",
        cbcTypes: "CBC Types:",
        lipidProfileTypes: "Lipid Profile Types:",
        diabetesTests: "Diabetes Tests:",
        electrolyteTests: "Electrolyte Tests:",
        cancerTests: "Cancer Tests:",
        thyroidPanelTests: "Thyroid Panel Tests:",
        remarks: "Remarks:",
        noRemarksProvided: "No remarks provided",

        documents: "Documents",
        notAvailable: "N/A"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर:",
        tokenNo: "टोकन क्रमांक:",
        beneficiaryName: "लाभार्थीचे नाव:",
        campDate: "शिबिर तारीख:",
        createdBy: "तयार केले:",

        testTypesAndRemarks: "चाचणी प्रकार आणि शेरा",
        cbcTypes: "CBC प्रकार:",
        lipidProfileTypes: "लिपिड प्रोफाइल प्रकार:",
        diabetesTests: "मधुमेह चाचण्या:",
        electrolyteTests: "इलेक्ट्रोलाइट चाचण्या:",
        cancerTests: "कर्करोग चाचण्या:",
        thyroidPanelTests: "थायरॉइड पॅनेल चाचण्या:",
        remarks: "शेरा:",
        noRemarksProvided: "कोणतीही टिप्पणी दिली नाही",

        documents: "कागदपत्रे",
        notAvailable: "उपलब्ध नाही"
    }
};
